import {common,grey, orange, cyan, pink, purple,blue,green,red} from '@mui/material/colors';

const {white} = common;

export const corestyles = {
  navigation: {
    fontSize: 15,
    fontWeight: 300,
    color: grey['600'],
    paddingBottom: 15,
    display: 'block'
  },
  title: {
    fontSize: 24,
    fontWeight: 300,
    marginBottom: 20,
    color:'white'
  },
  paper: {
    padding: 30
  },
  clear: {
    clear: 'both'
  },
  ////// service styles //////
  container: {
    display: 'flex',
  // flexWrap: 'wrap',
  },
  dialog: {
    width: '100%',
    minHeight: 600,
  },
  winDialog: {
    width: '100%',
    minHeight: 600,
  },
  winPaper: {
    width: '100%',
    minHeight: 600,
  },
  titlebar: {
    padding:0,
    backgroundColor: 'secondary.main',
  },
  reqform: {
    width: 450
  },
  textField: {
    ml: 1,
    mr: 1,
  // width: 800,
  },
  preview: {
    width:200,
    height: 40,
    mt: 1,
    ml: 1,
    mr: 1,
  },
  hide:{
    display:'none',
  },
  fixedfab: {
    backgroundColor: 'secondary.main', 
    margin: 0,
    top: 'auto',
    right: 20,
    bottom: 20,
    left: 'auto',
    position: 'fixed',
    color: white
  },
  actionfab: {
    fill: white
  },
  saveButton: {
    marginLeft: 5
  },
  buttons: {
    fixed: {
      backgroundColor:pink['500'], 
      margin: 0,
      top: 'auto',
      right: 20,
      bottom: 20,
      left: 'auto',
      position: 'fixed',
      color: white
    },
    action: {
      fill: white
    },
    save: {
      marginLeft: 5
    },
    cancel: {
      marginRight: 5
    } 
  },
  columns: {
    auto: {
      width: 'auto',
    },
    name: {
      width: '30%'
    },
    view: {
      width: '10%'
    },
    action: {
      width: '20px'
    }
  },
  //columnform
  columnform: {
    display: 'flex',
    flex:1,
    justifyContent: 'space-around'
  },
  columnfieldset: {
    flex: '1 1 0',
    marginRight: 10,
  },
  ////// status styles //////
  disabled: {
    color: grey['500'],
  },
  requested: {
    color: orange['500'],
  },
  accessed: {
    color: pink['700'],
  },
  submitted: {
    color: blue['300'],
  },
  processing: {
    color: blue['700'],
  },
  passed: {
    color: green['500'],
  },
  failed: {
    color: red['500'],
  },
  unauthorized: {
    color: purple['500'],
  },
  unknown: {
    color: cyan['500'],
  },
};

export default corestyles;
